import { action, computed, observable } from 'mobx'

import { ELOCK_PERMISSIONS } from 'sections/LKSection/modules/EmployeeModule/data'
import { UserELockRoleDTO } from 'sections/LKSection/modules/EmployeeModule/types/typesDTO'
import { Entity } from 'shared/stores/BaseStore'

export class EmployeeELockRole extends Entity {
  @observable userId = 0
  @observable role = ELOCK_PERMISSIONS.none

  @observable cachedRole = ELOCK_PERMISSIONS.none

  constructor(
    props: Omit<
      EmployeeELockRole,
      /* Здесь перечислены свойства, которых нет в DTO модели */
      'setRole' | 'resetRole' | 'hasRoleChanges'
    >,
  ) {
    super(props)
    Object.assign(this, props)
  }

  static create({ pickpointId, elockPermission, userId }: UserELockRoleDTO) {
    return new EmployeeELockRole({ id: pickpointId, cachedRole: elockPermission, role: elockPermission, userId })
  }

  @computed
  get hasRoleChanges() {
    return this.role !== this.cachedRole
  }

  @action
  setRole = (value: ELOCK_PERMISSIONS) => {
    this.role = value
  }

  @action
  resetRole = () => {
    this.role = this.cachedRole
  }
}
